var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Hero'),_c('Shorten',{attrs:{"urls":_vm.urls,"error":_vm.error,"loading":_vm.loading},on:{"termChange":_vm.onTermChange}}),_c('Statistics'),_c('Action'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }